import { render, staticRenderFns } from "./ActualizaEstatus.vue?vue&type=template&id=63dd637a&scoped=true"
import script from "./ActualizaEstatus.vue?vue&type=script&lang=js"
export * from "./ActualizaEstatus.vue?vue&type=script&lang=js"
import style0 from "./ActualizaEstatus.vue?vue&type=style&index=0&id=63dd637a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd637a",
  null
  
)

export default component.exports